import { defineMessages } from 'react-intl';

export default defineMessages({
  finished: { defaultMessage: 'Finished' },
  pending: { defaultMessage: 'Pending' },
  failed: { defaultMessage: 'Failed' },
});
